import React from 'react';
import {connect} from "react-redux";

const ToggleTTLSeconds = ({ label, isNumberInputSelected, handleToggleChange, handleInputChange, numberInput }) => {
    return (
        <div className="filter-group">
            <div className="filter-group-header">
                <label className="checkbox-wrapper">
                    <input type="checkbox" className="checkbox" checked={isNumberInputSelected} onChange={handleToggleChange} />
                    {label}
                </label>
            </div>
            {isNumberInputSelected &&
                <div className="filter-group-content">
                    <div className="filter-rule">
                        <div className="input-container">
                            <input name="numberInput" onChange={handleInputChange} className="number-input" type="number" value={numberInput} />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {};
};

export default connect(mapStateToProps, {})(ToggleTTLSeconds);